import React from 'react';

export const CodeExecutor = () => {
  return (
    <div className="flex items-center justify-center h-full min-h-[60vh]">
      <div className="text-center">
        <div className="text-6xl mb-4">⚡</div>
        <div className="text-2xl text-white font-bold mb-2">Coming Soon!</div>
        <div className="text-xl text-white/60 mb-1">Code Executor</div>
        <div className="text-white/40 text-sm">
          Execute • Visualize • Debug
        </div>
      </div>
    </div>
  );
};
